import type { EndpointSpec } from '../../../components/apidocs';

/** System Status API — สถานะเปิด/ปิดของระบบ + ยอดขั้นต่ำ */
export const SYSTEM_STATUS_ENDPOINTS: EndpointSpec[] = [
  {
    method: 'GET',
    path: '/system-status',
    description: 'ดึงสถานะเปิด/ปิดของระบบฝาก, ถอน และ Settlement พร้อมยอดขั้นต่ำ',
    response: {
      status: 200,
      id: 'system-status-res',
      code: `{
  "success": true,
  "data": {
    "deposit_enabled": true,
    "payout_enabled": true,
    "settlement_enabled": true,
    "min_deposit_amount": 300,
    "min_payout_amount": 300,
    "min_settlement_amount": 300
  }
}`,
    },
    responseFields: {
      rows: [
        { name: 'deposit_enabled', type: 'boolean', description: 'ระบบรับฝาก (สร้าง Order) เปิดอยู่หรือไม่' },
        { name: 'payout_enabled', type: 'boolean', description: 'ระบบถอนเงิน (Payout) เปิดอยู่หรือไม่' },
        { name: 'settlement_enabled', type: 'boolean', description: 'ระบบถอนเงิน (Settlement) เปิดอยู่หรือไม่' },
        { name: 'min_deposit_amount', type: 'number', description: 'ยอดฝากขั้นต่ำ (บาท) — 0 หมายถึงไม่จำกัด' },
        { name: 'min_payout_amount', type: 'number', description: 'ยอดถอนขั้นต่ำ (บาท)' },
        { name: 'min_settlement_amount', type: 'number', description: 'ยอดแจ้งถอนขั้นต่ำ (บาท)' },
      ],
    },
  },
];
